import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import {Observable} from 'rxjs';
import {RestService} from '../shared/rest/rest.service';
import {map} from 'rxjs/operators';
import {EnvironmentService} from "bos-commons";

@Injectable({
  providedIn: 'root'
})
export class UserLoggedRedirectGuard implements CanActivate {

  constructor(private restService: RestService, private router: Router, private env: EnvironmentService) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.activateAction(state);
  }

  public activateAction(state?: RouterStateSnapshot): Observable<boolean> | Promise<boolean> {
    return this.restService.isUserLogged().toPromise().then(v => {
      if (v && !state.url.includes('logout')) {
        this.restService.getDefaultRedirectUrl().subscribe(url => {
          window.location.href = url;
        }, error => {
          console.error("unable to get redirect url!", error);
          return false;
        })

      } else {
        return true;
      }
    }).catch(err => {
      return Promise.resolve(true);
    });
  }

}
